export const SUPPORT_USER_TICKETS = "SUPPORT_USER_TICKETS";
export const ADMIN_LOGIN_REQUEST = "ADMIN_LOGIN_REQUEST";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT = "LOGOUT";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILED = "REGISTER_FAILED";
export const FORGET_PASSWORD_REQUEST = "FORGET_PASSWORD_REQUEST";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_FAILED = "FORGET_PASSWORD_FAILED";
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";
export const GET_QUOTE_REQUEST = "GET_QUOTE_REQUEST";
export const GET_QUOTE_SUCCESS = "GET_QUOTE_SUCCESS";
export const GET_QUOTE_FAILED = "GET_QUOTE_FAILED";
export const SUPPORT_USER_REQUEST = "SUPPORT_USER_REQUEST";
export const SUPPORT_USER_SUCCESS = "SUPPORT_USER_SUCCESS";
export const SUPPORT_USER_FAILED = "SUPPORT_USER_FAILED";
export const CHECK_NDA_REQUEST = "CHECK_NDA_REQUEST";
export const CHECK_NDA_SUCCESS = "CHECK_NDA_SUCCESS";
export const CHECK_NDA_FAILED = "CHECK_NDA_FAILED";
export const CONTACT_US_REQUEST = "CONTACT_US_REQUEST";
export const CONTACT_US_SUCCESS = "CONTACT_US_SUCCESS";
export const CONTACT_US_FAILED = "CONTACT_US_FAILED";
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILED = "CHANGE_PASSWORD_FAILED";
export const REQUEST_GITHUB_REQUEST = "REQUEST_GITHUB_REQUEST";
export const REQUEST_GITHUB_SUCCESS = "REQUEST_GITHUB_SUCCESS";
export const REQUEST_GITHUB_FAILED = "REQUEST_GITHUB_FAILED";
export const UPDATE_USER_STATUS_REQUEST = "UPDATE_USER_STATUS_REQUEST";
export const UPDATE_USER_STATUS_SUCCESS = "UPDATE_USER_STATUS_SUCCESS";
export const UPDATE_USER_STATUS_FAILED = "UPDATE_USER_STATUS_FAILED";
export const UPDATE_API_STATUS_REQUEST = "UPDATE_API_STATUS_REQUEST";
export const UPDATE_API_STATUS_SUCCESS = "UPDATE_API_STATUS_SUCCESS";
export const UPDATE_API_STATUS_FAILED = "UPDATE_API_STATUS_FAILED";
export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILED = "CREATE_USER_FAILED";
export const QUESTIONNAIRE_SUCESS = "QUESTIONNAIRE_SUCESS";
export const QUESTIONNAIRE_FAILED = "QUESTIONNAIRE_FAILED";
export const SEND_EMAIL_MODAL = "SEND_EMAIL_MODAL";
export const RECENT_EMAIL_MODAL = "RECENT_EMAIL_MODAL";
export const RECENT_EMAIL_ATTACHMENT_DOWNLOAD =
  "RECENT_EMAIL_ATTACHMENT_DOWNLOAD";
